/**
 * KPIs users may edit in Executive Pulse (Oracle UI). Keep ids aligned with
 * `EXECUTIVE_PULSE_UI_EDITABLE_KPI_IDS` in oracle-backend
 * `executive-pulse-kpi-catalog.js`.
 */
const EXECUTIVE_PULSE_UI_EDITABLE_KPI_IDS = Object.freeze([
    'ep-process-people-vision-2028',
    'ep-process-12-month-plan',
    'ep-customer-qbr-process',
    'ep-customer-delivered-practices-80pct',
    'ep-customer-digital-100pct',
    'ep-customer-churn-reduction-10pct',
    'ep-growth-1a-q1-2026',
    'ep-growth-1b-q2-2026'
]);

export default EXECUTIVE_PULSE_UI_EDITABLE_KPI_IDS;
